module.exports = __webpack_public_path__ + "img/classic_6.f052d29a.jpg";